export default "__VITE_ASSET__ukxhikop__"